import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="work-types--table"
export default class extends Controller {
    static targets = ["table"];

    edit(event) {
        this.tableTarget.querySelectorAll("tr").forEach((tr) => {
            tr.classList.remove("active");
        });
        event.currentTarget.closest("tr").classList.add("active");
    }
}
